import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PortalPageHeader } from "@/components/portal/PortalLayout";
import { Download } from "lucide-react";
import { toast } from "sonner";

export default function PartnerStatements() {
  const [statements, setStatements] = useState([]);
  useEffect(() => { api.get("/partner/statements").then((r) => setStatements(r.data)); }, []);
  const download = (s) => toast.info(`PDF export for ${s.month} — coming with Moloni integration.`);
  return (
    <div className="p-10 max-w-[1200px]">
      <PortalPageHeader eyebrow="Finance" title="Monthly statements" description="Every month you earn commission on every paid booking. Download the invoice PDF for your accounting." />
      <div className="bg-white border border-slate-200 shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
              <th className="p-4">Month</th>
              <th className="p-4 text-right">Bookings</th>
              <th className="p-4 text-right">Gross revenue</th>
              <th className="p-4 text-right">Your commission</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {statements.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-slate-500">No statements yet.</td></tr>}
            {statements.map((s) => (
              <tr key={s.month} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`stmt-row-${s.month}`}>
                <td className="p-4 text-[#0a0f1e] font-mono">{s.month}</td>
                <td className="p-4 text-right text-slate-700">{s.bookings}</td>
                <td className="p-4 text-right font-mono text-slate-700">€{s.revenue.toFixed(2)}</td>
                <td className="p-4 text-right font-mono text-[#f59e0b] font-semibold">€{s.commission.toFixed(2)}</td>
                <td className="p-4">
                  <button onClick={() => download(s)} className="inline-flex items-center gap-2 text-xs uppercase text-slate-500 hover:text-[#f59e0b]">
                    <Download className="w-3 h-3" /> PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
